<ng-container *ngIf="control">
  <div class="p-float-label">
    <p-dropdown
      class="p-inputwrapper-focus"
      [ngClass]="uppercaseOnEdit && control.value?.trim() ? 'text-uppercase' : ''"
      [options]="source"
      [formControl]="control"
      [filter]="filter"
      [filterBy]="filterBy"
      [showClear]="showClear"
      [optionLabel]="optionLabel"
      [optionValue]="optionValue"
      [placeholder]="placeholder"
      [editable]="editable"
      [required]="required"
      [group]="group"
      appendTo="body"
    >
      <ng-template pTemplate="selectedItem" let-selectedOption>
        <div class="flex align-items-center gap-2">
          <div>
            {{
              (invertLabelExtra && optionLabelExtra ? selectedOption[optionLabelExtra] + ' | ' : '') +
                selectedOption[optionLabel] +
                (optionLabelExtra && !invertLabelExtra ? ' | ' + selectedOption[optionLabelExtra] : '')
            }}
          </div>
        </div>
      </ng-template>
      <ng-template let-code pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>
            {{
              (invertLabelExtra && optionLabelExtra ? code[optionLabelExtra] + ' | ' : '') +
                code[optionLabel] +
                (optionLabelExtra && !invertLabelExtra ? ' | ' + code[optionLabelExtra] : '')
            }}
          </div>
        </div>
      </ng-template>
    </p-dropdown>
    <label [ngClass]="{ required: required, 'label-disabled': isDisabled }">{{ name }}</label>
  </div>
</ng-container>
